/* src/pages/DataBackupRecovery.js */

import React from "react";
import PageSection from "../components/PageSection";
import { Helmet } from "react-helmet";
import styles from "./Pages.module.css"; // CSS Module
import dataBackupImage from "../assets/Images/data-backup.jpg";

function DataBackupRecovery() {
  const faqs = [
    {
      question: "Do I really need backups?",
      answer:
        "If you'd be screwed without your files, yes. Hard drives fail, ransomware encrypts everything, people accidentally delete stuff. Backups are your insurance policy.",
    },
    {
      question: "What if I lose data?",
      answer:
        "If you have backups set up properly, I can restore your files - usually pretty quickly. If you DON'T have backups, your options are expensive data recovery services or starting over. Don't wait until it's too late.",
    },
    {
      question: "Where do you back things up?",
      answer:
        "Usually to the cloud (like Microsoft OneDrive, Google Drive, or specialized backup services). Cloud backups run automatically and protect you even if your office burns down or gets hit by ransomware.",
    },
  ];

  return (
    <PageSection title="Data Backup & Recovery Solutions for Shreveport-Bossier Businesses" cta faqs={faqs}>
      <Helmet>
        <title>Data Backup & Recovery Services | Tharpe Industries</title>
        <meta
          name="description"
          content="Affordable, reliable data backup and recovery solutions for Shreveport-Bossier businesses. Protect your critical information and ensure business continuity with our local IT services."
        />
      </Helmet>
      <div className={styles.contentContainerReverse}>
        <img
          src={dataBackupImage}
          alt="Data Backup & Recovery"
          className={styles.pageImage}
          loading="lazy"
        />
        <div className={styles.textContent}>
          <h3>Hope Is Not a Backup Strategy</h3>
          <p>
            Hard drives fail. Ransomware happens. People accidentally delete stuff. If you don't have backups, 
            you're gambling with your business data - and the house always wins eventually.
          </p>
          <p>
            I help Shreveport-Bossier businesses set up automatic backups that actually work. No more manually 
            copying files to an external drive (that you forget to do). Cloud-based backups run automatically 
            and protect you even if your office floods, burns down, or gets hit by ransomware.
          </p>
          
          <h3>What I Set Up:</h3>
          <ul>
            <li>Automatic daily backups to the cloud</li>
            <li>Easy file recovery when someone deletes something important</li>
            <li>Protection against ransomware (can't encrypt your cloud backups)</li>
            <li>Regular testing to make sure backups actually work</li>
            <li>Simple monthly pricing - no surprise bills</li>
          </ul>
          <p>
            Don't wait until it's too late. Setting up proper backups NOW is way cheaper than losing years of 
            business data or paying ransom to hackers. Let me help you sleep better at night.
          </p>
        </div>
      </div>
    </PageSection>
  );
}

export default DataBackupRecovery;
